var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('p',{staticClass:"satisfaction-icons mb-0"},[_c('i',{class:[
                'satisfaction-icon',
                'fa',
                'fa-smile-o',
                'mr-2',
                {
                    'satisfaction-icon-selected text-success':
                        _vm.satisfaction.smile,
                },
            ],on:{"click":function($event){return _vm.onClickSatisfaction('smile')}}}),_c('i',{class:[
                'satisfaction-icon',
                'fa',
                'fa-meh-o',
                'mr-2',
                {
                    'satisfaction-icon-selected text-warning':
                        _vm.satisfaction.meh,
                },
            ],on:{"click":function($event){return _vm.onClickSatisfaction('meh')}}}),_c('i',{class:[
                'satisfaction-icon',
                'fa',
                'fa-frown-o',
                {
                    'satisfaction-icon-selected text-danger':
                        _vm.satisfaction.frown,
                },
            ],on:{"click":function($event){return _vm.onClickSatisfaction('frown')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }